import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import useHttp from "../../../../hook/use-http";
import { ThreeCircles } from "react-loader-spinner";
import { API_URL_MAIN } from "../../../../constants/driveglobalfilterinitalstates";
import { BatteryPlus } from "lucide-react";


const TOP_KPIS_SECOND_PAGE_MAIN = {
  distance_travelled: 0,
  distance_travelled_start: 0,
  distance_travelled_end: 0,
  discharge_cycle: 0,
  median_range: 0,
  median_whr_km: 0,
  median_cons_range: 0,
  median_disc_cycle: 0,
  median_disc_dur: 0,
  median_active_time: 0,
  median_idle_percent: 0,
  median_idle_time: 0,
  median_regen_time: 0,
  median_regen_percent: 0,
};

function TopkpisSecondMainErc({ gloablfilter, apiend }) {
  const [topdata, setTopData] = useState(TOP_KPIS_SECOND_PAGE_MAIN);
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [modaldata, setModaldata] = useState([]);
  const [soh, setsoh] = useState([]);

  const appyData = (data) => {
    const res_result = data;
    if (res_result.length !== 0) {
      const temp_result = res_result;
      const responce = {

        distance_travelled: parseFloat(temp_result.Distance_Travelled.value ?? 0).toFixed(2),
        distance_travelled_start: parseFloat(temp_result.startOdo.value ?? 0).toFixed(2),
        distance_travelled_end: parseFloat(temp_result.endOdo.value ?? 0).toFixed(2),
        discharge_cycle: parseFloat(temp_result.Discharge_Cycle.value ?? 0).toFixed(2),
        median_range: parseFloat(temp_result.Median_Range.values["50.0"] ?? 0).toFixed(2),
        median_whr_km: parseFloat(temp_result.Median_Wh_Km.values["50.0"] ?? 0).toFixed(2),
        median_cons_range: parseFloat(temp_result.NetkWh.values["50.0"] ?? 0).toFixed(2),
        median_disc_cycle: parseFloat(temp_result.Median_Discharge_Cycle.values["50.0"] ?? 0).toFixed(2),
        median_disc_dur: parseFloat(temp_result.Median_Discharge_Duration.values["50.0"] ?? 0).toFixed(2),
        median_active_time: parseFloat(temp_result.Median_Active_Time.values["50.0"] ?? 0).toFixed(2),
        median_idle_percent: parseFloat(temp_result.Median_Idle_Time_Percent.values["50.0"] ?? 0).toFixed(2),
        median_idle_time: parseFloat(temp_result.Median_Idle_Time.values["50.0"] ?? 0).toFixed(2),
        median_regen_time: parseFloat(temp_result.Median_Regen_Time.values["50.0"] ?? 0).toFixed(2),
        median_regen_percent: parseFloat(temp_result.Median_Regen_Time_Percent.values["50.0"] ?? 0).toFixed(2),

      };
      setTopData(responce);
    }
  };

  useEffect(() => {
    fetchData(
      {
        url: API_URL_MAIN + apiend,
        body: { filterdata: gloablfilter },
      },
      appyData
    );
  }, [gloablfilter]);
  useEffect(() => {
    fetchData(
      {
        url: API_URL_MAIN + "jupiter_drive_analysis/min_SOH", // Replace with your real endpoint
        body: {
          filterdata: gloablfilter
        },
      },
      (response) => {
        // Safely check if response has at least one item
        if (Array.isArray(response) && response.length > 0) {
          const soh = response[0]?.Minimum_SOH?.value;
          setsoh(soh);
        }
      }
    );
  }, []);

  const loader = (
    <div style={{ margin: "auto" }}>
      <ThreeCircles
        height="50"
        width="40"
        wrapperStyle={{}}
        wrapperClass=""
        visible={true}
        ariaLabel="three-circles-rotating"
        outerCircleColor="#3498db"
        innerCircleColor="#dec52d"
        middleCircleColor="#db213a"
      />
    </div>
  );

  const appyDataModal = (data) => {
    if (data.length != 0) {
      let temp_result = data;
      setModaldata(temp_result);
    } else {
      setModaldata([]);
    }
  };

  const handlePlatformChange = (event) => {
    const toggel = event.target.innerText;
    if (toggel === "Discharge cycles")
      fetchData(
        {
          url: API_URL_MAIN + "jupiter_drive_analysis/discharge_modal_erc",
          body: { filterdata: gloablfilter },
        },
        appyDataModal
      );
    else
      fetchData(
        {
          url: API_URL_MAIN + "jupiter_drive_analysis/outliers_modal_erc",
          body: { filterdata: gloablfilter },
        },
        appyDataModal
      );
  };

  const loadModalData = () => {
    fetchData(
      {
        url: API_URL_MAIN + "jupiter_drive_analysis/discharge_modal_erc",
        body: { filterdata: gloablfilter },
      },
      appyDataModal
    );
    window.$("#Dischargecycles").addClass("active");
    window.$("#outliers").removeClass("active");
  };

  const modal_column = [
    "vehicleId",
    "eventdate",
    "startTime",
    "endTime",
    "dischargeDuration",
    "startOdo",
    "endOdo",
    "max_odometer",
    "distanceInKM",
    "startSoc",
    "endSoc",
    "dischargeSoc",
    "startDte",
    "endDte",
    "deltaDte",
    "errorDte",
    "Range",
    "startPack",
    "endPack",
    "NetkWh",
    "whPerKM",
    "discharge",
    "Vehicle_Active_Time",
    "Vehicle_Inactive_Time",
    "Vehicle_Idle_Time",
    "Vehicle_Regen_Time",
    "Vehicle_Inactive_Time_Percent",
    "Vehicle_Idle_Time_Percent",
    "Vehicle_Regen_Time_Percent",
    "Median_Motor_Temperature",
    "Max_Motor_Temperature",
    "Median_Throttle_Forward_Motoring",
    "Max_Throttle_Forward_Motoring",
    "Median_Torque_Forward_Motoring",
    "Max_Torque_Forward_Motoring",
    "Median_RPM_Forward_Motoring",
    "Max_RPM_Forward_Motoring",
    "Median_Vehicle_Speed_Forward_Motoring",
    "Max_Vehicle_Speed_Forward_Motoring",
    "Median_Torque_Forward_Regen",
    "Max_Torque_Forward_Regen",
    "Median_RPM_Forward_Regen",
    "Max_RPM_Forward_Regen",
    "Median_Torque_Reverse_Motoring",
    "Max_Torque_Reverse_Motoring",
    "Median_RPM_Reverse_Motoring",
    "Max_RPM_Reverse_Motoring",
    "Median_Vehicle_Speed_Reverse_Motoring",
    "Max_Vehicle_Speed_Reverse_Motoring",
    "Median_MCU_Temperature",
    "Max_MCU_Temperature",
    "Median_MCU_Current_Motoring",
    "Max_MCU_Current_Motoring",
    "Median_MCU_Current_Regen",
    "Max_MCU_Current_Regen",
    "Median_BMS_Max_Cell_Temperature",
    "Max_BMS_Max_Cell_Temperature",
    "Median_BMS_Min_Cell_Temperature",
    "Min_BMS_Min_Cell_Temperature",
    "Max_BMS_Max_Cell_Voltage",
    "Median_BMS_Max_Cell_Voltage",
    "Min_BMS_Min_Cell_Voltage",
    "Median_BMS_Min_Cell_Voltage",
    "Median_Delta_Cell_Voltage",
    "Max_Delta_Cell_Voltage",
    "Median_BMS_Pack_Current_Motoring",
    "Max_BMS_Pack_Current_Motoring",
    "Median_BMS_Pack_Current_Regen",
    "Max_BMS_Pack_Current_Regen",
    "SOH",
    "BCS_active_time",
    "BCS_Active_Time_Percent",
    "Median_BCS_Coolant_In",
    "Max_BCS_Coolant_In",
    "Median_BCS_Coolant_Out",
    "Max_BCS_Coolant_Out",
    "Max_BCS_Suction_Pressure",
    "Max_BCS_Discharge_Pressure",
    "Max_BCS_Delta_Compressor_Pressure",
    "Max_BCS_Comp_RPM",
    "Median_BCS_Comp_RPM",
    "Max_BCS_Comp_Current",
    "Median_BCS_Comp_Current",
    "Median_BCS_Comp_Temp",
    "Max_BCS_Comp_Temp",
    "Median_DCDC_Output_Current_Day",
    "Max_DCDC_Output_Current_Day",
    "Median_DCDC_Output_Current_Night",
    "Max_DCDC_Output_Current_Night",
    "Median_DCDC_Output_Voltage",
    "Max_DCDC_Output_Voltage",
    "Median_DCDC_Temperature2",
    "Max_DCDC_Temperature2",
    "Median_DCDC_Output_Voltage",
    "Max_DCDC_Output_Voltage",
    "Vehicle_Brake_Active_Time",
    "Min_LV_Battery_Voltage_Ignition_Off",
    "Max_LV_Battery_Voltage_Ignition_Off",
    "Median_LV_Battery_Voltage_Ignition_Off",
    "eco_drive_percent",
    "Median_Throttle_Reverse_Motoring",
    "power_drive_percent",
    "low_regen_mode_percent",
    "mid_regen_mode_percent",
    "high_regen_mode_percent",
    "Median_Throttle_Forward_Regen",
    "Max_Throttle_Forward_Regen",
    "Median_Torque_Reverse_Regen",
   "Max_Torque_Reverse_Regen",
    "Max_RPM_Reverse_Regen",
    "Vehicle_Drive_Time",
    "Max_Cabin_temperature",
    "AC_active_time",
    "AC_active_time_percent",
    "Median_Cabin_temperature",
    "Median_BCS_Comp_Temp",
    "Max_BCS_Comp_Temp",
    "Max_Throttle_Reverse_Motoring",
    "LOB",
    "PL",
    "PPL",
    "DLR_NAME",
    "DLR_REGION",
    "DLR_STATE",
    // "invoice_dt",
    "DLR_ORG_CITY",

  ];

  return (
    <>
      <div
        className="modal fade"
        id="staticBackdrop"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <div
                style={{ marginLeft: "2%" }}
                className="btn-group btn-group-toggle"
                data-toggle="buttons"
                onClick={handlePlatformChange}
              >
                <label
                  className="btn btn-infotable active"
                  id="Dischargecycles"
                >
                  <input
                    type="radio"
                    name="platform"
                    value="Discharge cycles"
                    autoComplete="off"
                  />{" "}
                  Discharge cycles
                </label>
                <label className="btn btn-infotable" id="outliers">
                  <input
                    type="radio"
                    name="platform"
                    value=" Outliers"
                    autoComplete="off"
                  />{" "}
                  Outliers
                </label>
              </div>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div
                className="tablecontainer"
                style={{ overflowX: "scroll", minHeight: "300px" }}
              >
                <table
                  className="table table-striped"
                  style={{ width: "1500px" }}
                >
                  <thead
                    style={{
                      backgroundColor: "#32879c",
                      color: "#fff",
                      position: "sticky",
                      top: 0,
                      zIndex: 0,
                    }}
                  >
                    <tr>
                      <th scope="col">Cycle</th>
                      {modal_column.map((header, index) => (
                        <th key={index}>{header}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {isLoading ? (
                      loader
                    ) : modaldata.length === 0 ? (
                      <tr>
                        <td
                          colSpan="17"
                          className="alert alert-danger no_data"
                          style={{ background: "#f4c2ce" }}
                        >
                          No records found
                        </td>
                      </tr>
                    ) : (
                      modaldata.map((x, index) => {
                        return (
                          <tr key={index}>
                            <td
                              scope="row "
                              style={{ padding: "3px", textAlign: "center" }}
                            >
                              {index + 1}
                            </td>
                            {modal_column.map((header, index) => {
                              let value = x._source[header];

                              if (
                                (header === "BCS_active_time" || header === "BCS_Active_Time_Percent") &&
                                (value === 0 || value === "0")
                              ) {
                                value = "";
                              }

                              return <td key={index}>{value}</td>;
                            })}
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>


      <section className="kpi my-3">
        <div className="row row-cols-2">
          <div className="col">
            <div className="widget widgetstyle p-2 py-2 d-flex align-items-center" style={{ marginLeft: 0 }}>
              <div className="widgetIcon">
                <img src="/assets/img/charging-station-2.png" />
              </div>
              <div className="ps-2" data-bs-toggle="modal" data-bs-target="#staticBackdrop" style={{ cursor: "pointer" }} onClick={loadModalData}>
                <p className="h5 m-0 kpi_value">{topdata.discharge_cycle}</p>
                <p className="m-0"><small className="text-muted drive_span">Discharge Cycle</small></p>
              </div>
            </div>
          </div>

          <div className="col evtpks-pl0">
            <div className="widget widgetstyle p-2 py-2 d-flex align-items-center" style={{ marginLeft: 0 }}>
              <div className="widgetIcon">
                <img src={"/assets/img/charging-1.png"} />
              </div>
              <div className="pl-1" style={{ width: "74%", display: "inline-block" }}>
                <div>
                  <div className="fst" style={{ borderBottom: "none", marginRight: "1px", float: "right", fontSize: "10px" }}>
                    <b style={{ borderBottom: "solid 2px #ffa650" }} className="charging_cy" id="charging_cy_fast">
                      {topdata.distance_travelled_start}
                    </b>{" "}Start
                  </div>
                  <div className="sl" style={{ borderBottom: "none", fontSize: "10px" }}>
                    <b style={{ borderBottom: "solid 2px #1494ac" }} className="charging_cy" id="charging_cy_slow">
                      {topdata.distance_travelled_end}
                    </b>{" "}End
                  </div>
                  <p className="h5 m-0 pt-1 kpi_value"></p>
                  <p className="m-0"><small className="text-muted drive_span">ODO</small></p>
                </div>
              </div>
            </div>
          </div>
          <div className="col evtpks-pl0">
            <div className="widget widgetstyle p-2 py-2 d-flex align-items-center" style={{ marginLeft: 0 }}>
              <div className="widgetIcon pl-1">
                <img src="/assets/img/charging-1.png" alt="" />
              </div>
              <div className="ps-2">
                <p className="h5 m-0 kpi_value">{topdata.distance_travelled} km</p>
                <p className="m-0 kpi_text"><small className="text-muted drive_span">Distance Travelled</small></p>
              </div>
            </div>
          </div>
          <div className="col evtpks-pl0">
            <div className="widget widgetstyle p-2 py-2 d-flex align-items-center" style={{ marginLeft: 0 }}>
              <div className="widgetIcon">
                <img src="/assets/img/charging-station1.png" />
              </div>
              <div className="ps-3">
                <p className="h5 m-0 kpi_value">{topdata.median_range} km</p>
                <p className="m-0"><small className="text-muted drive_span">Median Range</small></p>
              </div>
            </div>
          </div>

          <div className="col evtpks-pl0">
            <div className="widget widgetstyle p-2 py-2 d-flex align-items-center" style={{ marginLeft: 0 }}>
              <div className="widgetIcon">
                <img src="/assets/img/electric1.png" />
              </div>
              <div className="ps-3">
                <p className="h5 m-0 kpi_value">{topdata.median_whr_km}</p>
                <p className="m-0"><small className="text-muted drive_span">Median Wh/km</small></p>
              </div>
            </div>
          </div>

          <div className="col evtpks-pl0">
            <div className="widget widgetstyle p-2 py-2 d-flex align-items-center" style={{ marginLeft: 0 }}>
              <div className="widgetIcon">
                <img src="/assets/img/electric-car1.png" />
              </div>
              <div className="ps-3">
                <p className="h5 m-0 kpi_value">{topdata.median_cons_range} kwh</p>
                <p className="m-0"><small className="text-muted drive_span">Median Cons./Cycle</small></p>
              </div>
            </div>
          </div>

          <div className="col evtpks-pl0">
            <div className="widget widgetstyle p-2 py-2 d-flex align-items-center" style={{ marginRight: 0 }}>
              <div className="widgetIcon">
                <img src="/assets/img/battery-charge-1.png" />
              </div>
              <div className="ps-0">
                <p className="h5 m-0 kpi_value">{topdata.median_disc_cycle} %</p>
                <p className="m-0"><small className="text-muted drive_span">Med. Discharge/Cycle</small></p>
              </div>
            </div>
          </div>
        </div>

        <div className="row row-cols-2 mt-2">
          <div className="col ">
            <div className="widget widgetstyle p-2 py-2 d-flex align-items-center" style={{ marginLeft: 0 }}>
              <div className="widgetIcon pl-1">
                <img src={"/assets/img/dis_dur.png"} />
              </div>
              <div className="pl-0">
                <p className="h5 m-0 kpi_value">{topdata.median_disc_dur} mins</p>
                <p className="m-0"><small className="text-muted drive_span">Median Dis Duration</small></p>
              </div>
            </div>
          </div>

          <div className="col evtpks-pl0">
            <div className="widget widgetstyle p-2 py-2 d-flex align-items-center" style={{ marginLeft: 0 }}>
              <div className="widgetIcon pl-1">
                <img src="/assets/img/acti_time.png" alt="" />
              </div>
              <div className="ps-2">
                <p className="h6 m-0 kpi_value">{topdata.median_active_time} mins</p>
                <p className="m-0 kpi_text"><small className="text-muted drive_span ">Median  Active Time</small></p>
              </div>
            </div>
          </div>

          <div className="col evtpks-pl0">
            <div className="widget widgetstyle p-2 py-2 d-flex align-items-center" style={{ marginLeft: 0 }}>
              <div className="widgetIcon pl-1">
                <img src="/assets/img/idle_time.png" />
              </div>
              <div className="pl-1">
                <p className="h5 m-0 kpi_value">{topdata.median_idle_time} mins</p>
                <p className="m-0"><small className="text-muted drive_span">Median Idle Time</small></p>
              </div>
            </div>
          </div>

          <div className="col evtpks-pl0">
            <div className="widget widgetstyle p-2 py-2 d-flex align-items-center" style={{ marginLeft: 0 }}>
              <div className="widgetIcon pl-1">
                <img src="/assets/img/idle_per.png" alt="" />
              </div>
              <div className="ps-2">
                <p className="h5 m-0 kpi_value">{topdata.median_idle_percent} %</p>
                <p className="m-0 kpi_text"><small className="text-muted drive_span">Median Idle Time Percent</small></p>
              </div>
            </div>
          </div>


          <div className="col evtpks-pl0">
            <div className="widget widgetstyle p-2 py-2 d-flex align-items-center" style={{ marginLeft: 0 }}>
              <div className="widgetIcon pl-1">
                <img src="/assets/img/median_regen.png" />
              </div>
              <div className="pl-1">
                <p className="h5 m-0 kpi_value">{topdata.median_regen_time} mins</p>
                <p className="m-0"><small className="text-muted drive_span">Median Regen Time</small></p>
              </div>
            </div>
          </div>

          <div className="col evtpks-pl0">
            <div className="widget widgetstyle p-2 py-2 d-flex align-items-center" style={{ marginLeft: 0 }}>
              <div className="widgetIcon pl-1">
                <img src="/assets/img/Regen_percent.png" />
              </div>
              <div className="pl-1">
                <p className="h5 m-0 kpi_value">{topdata.median_regen_percent} %</p>
                <p className="m-0"><small className="text-muted drive_span">Median Regen Time%</small></p>
              </div>
            </div>
          </div>

          <div className="col evtpks-pl0">
            <div className="widget widgetstyle p-2 py-2 d-flex align-items-center" style={{ marginLeft: 0 }}>
              <div className="widgetIcon pl-1">

                <p> <BatteryPlus size={60} color="
#358696" /></p>
              </div>
              <div className="ps-2">
                <p className="h5 m-0 kpi_value">{soh !== null ? soh : "0"} </p>
                <p className="m-0 kpi_text"><small className="text-muted drive_span">Minimum_SOH</small></p>
              </div>
            </div>
          </div>

        </div>
      </section>
    </>
  );
}

export default TopkpisSecondMainErc;
